import React from "react";
import './App.css';
import {
  TransitionGroup,
  CSSTransition
} from "react-transition-group";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import LabelUploader from "./Label/Uploader/LabelUploader";
import Header from "./components/Header";
import Container from '@material-ui/core/Container';
import Groups from "./Groups/Groups";
import GroupDetail from "./Groups/GroupDetail";
import GroupSummary from "./Groups/GroupSummary";
import LabelDetail from "./Label/LabelDetail"
import LabelScanner from "./Label/Scanner/LabelScanner"
import Search from "./Search/Search"
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const MySwal = withReactContent(Swal)

function App() {
  

    return (
        <Router basename="/">
            <div className="App">
                <Homepage />
            </div>  
        </Router>
    );
}

function checkNewAppVersion() {
    fetch( process.env.REACT_APP_API_URL + "/version")
    .then(response => response.json())
    .then((response) => {
        if (localStorage.getItem("app-version") === undefined) {
            localStorage.setItem('app-version', response.value);
        } else if (localStorage.getItem("app-version") !== response.value) {
            console.log("new version avaiable");
            refreshCacheAndReload();
        }

        localStorage.setItem('app-version-lastcontrol', Date.now() + 1000 * 60 * 1);
    })
}

function getApiKey() {
    MySwal.fire({
		title: 'Inserisci la chiave segreta',
		input: 'password',
		inputAttributes: {
			autocapitalize: 'off'
		},
		showCancelButton: false,
		confirmButtonText: 'invia',
		showLoaderOnConfirm: true,
		preConfirm: (key) => {
			return fetch(process.env.REACT_APP_API_URL + "/key/get", {
				method: "POST", 
				headers: {
					'Content-Type': 'application/json'
				},
				redirect: 'follow',
				body: JSON.stringify({key: key})
			})
			.then(response => {
				if (response.status !== 401) {
					return response.json()
				} 
			})
			.catch(error => {
				Swal.showValidationMessage(
				`Errore: ${error}`
				)
			})
		},
		allowOutsideClick: () => !Swal.isLoading()
	}).then((result) => {
		if (result.value.BEARER_TOKEN) {
			localStorage.setItem("BEARER_TOKEN", result.value.BEARER_TOKEN);
		}

		window.location.reload();
	})
}

const refreshCacheAndReload = () => {
    if (caches) {
      caches.keys().then((names) => {
        for (const name of names) {
          caches.delete(name);
        }
      });
    }
    window.location.reload();
  };

function Homepage() {
    let location = useLocation();

    const [appVersion, setAppVersion] = React.useState(() => {
    	return localStorage.getItem("app-version")
    });

    let lastAppVersionControl = localStorage.getItem("app-version-lastcontrol");
    if (lastAppVersionControl === undefined || lastAppVersionControl < Date.now()) {
        checkNewAppVersion();
    }

	if (localStorage.getItem("BEARER_TOKEN") == null) {
		getApiKey();
	}

    return (
        <>
            <Header />
            <Container fixed className={"container"}>


                <Switch location={location}>
                    
                    <Route path="/upload" children={<LabelUploader />} />
                    <Route path="/scan" children={<LabelScanner />} />
                    <Route path="/search" children={<Search />} />
                    <Route path="/group/list" children={<Groups />} />
                    <Route path="/group/:groupId/label/:labelId" children={<LabelDetail />} />
                    <Route path="/group/:groupId/summary" children={<GroupSummary />} />
                    <Route path="/group/:groupId" children={<GroupDetail />} />
                    <Route path="/"  children={<Groups />} />
                
                </Switch>


            </Container>
        </>
    )

}


export default App;
